module.exports = __webpack_public_path__ + "img/32_20.50620517.png";